import { render, staticRenderFns } from "./LinkToCitizen.vue?vue&type=template&id=2df20633&scoped=true&"
import script from "./LinkToCitizen.vue?vue&type=script&lang=js&"
export * from "./LinkToCitizen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df20633",
  null
  
)

export default component.exports